import { useState } from 'react'
import { ClipboardList, Pencil, ArrowRight } from 'lucide-react'
import { LatestRegistrations } from './LatestRegistrations'
import { RegistrationModification } from './RegistrationModification'

type RegistrationsView = 'hub' | 'latest' | 'modification'

export function RegistrationsManagement() {
  const [currentView, setCurrentView] = useState<RegistrationsView>('hub')

  if (currentView === 'latest') {
    return (
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <button
            onClick={() => setCurrentView('hub')}
            className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-900 transition-colors"
          >
            <ArrowRight className="h-4 w-4 rotate-180" />
            Retour
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Dernieres inscriptions</h1>
            <p className="text-gray-600">Suivi des inscriptions recentes</p>
          </div>
        </div>
        <LatestRegistrations />
      </div>
    )
  }

  if (currentView === 'modification') {
    return <RegistrationModification onBack={() => setCurrentView('hub')} />
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Gestion des Inscriptions</h1>
        <p className="text-gray-600">Suivi et gestion de toutes les inscriptions</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <button
          onClick={() => setCurrentView('latest')}
          className="group relative bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left hover:shadow-md hover:border-blue-300 transition-all duration-200"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center group-hover:bg-blue-100 transition-colors">
              <ClipboardList className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Dernieres inscriptions</h3>
              <p className="text-sm text-gray-500">Consulter les inscriptions recentes, filtrer par periode et rechercher par enfant ou parent.</p>
            </div>
          </div>
          <ArrowRight className="absolute top-8 right-6 h-5 w-5 text-gray-300 group-hover:text-blue-500 transition-colors" />
        </button>

        <button
          onClick={() => setCurrentView('modification')}
          className="group relative bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-left hover:shadow-md hover:border-amber-300 transition-all duration-200"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-amber-50 rounded-lg flex items-center justify-center group-hover:bg-amber-100 transition-colors">
              <Pencil className="h-6 w-6 text-amber-600" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Modification / Suppression</h3>
              <p className="text-sm text-gray-500">Rechercher un enfant pour modifier ou supprimer une inscription existante.</p>
            </div>
          </div>
          <ArrowRight className="absolute top-8 right-6 h-5 w-5 text-gray-300 group-hover:text-amber-500 transition-colors" />
        </button>
      </div>
    </div>
  )
}
